// extracted by mini-css-extract-plugin
export default {"tooltip":"BS-z","arrow":"CS-z"};